interface MetasearchDiscountSelectorContext {
  enabled: boolean
  requestKey?: string
}

export function getMetasearchDiscountAmount(
  state: App.State,
  context: MetasearchDiscountSelectorContext,
): number {
  if (!context.enabled || !context.requestKey) {
    return 0
  }

  if (state.marketing.metasearchDiscount.requestKey !== context.requestKey) {
    return 0
  }

  if (state.marketing.metasearchDiscount.error) {
    return 0
  }

  const discountAmount = state.marketing.metasearchDiscount.discountAmount ?? 0

  return discountAmount > 0 ? discountAmount : 0
}

export function getIsMetasearchDiscountPending(
  state: App.State,
  context: MetasearchDiscountSelectorContext,
): boolean {
  if (!context.enabled || !context.requestKey) {
    return false
  }

  const discountState = state.marketing.metasearchDiscount

  return discountState.requestKey !== context.requestKey || discountState.discountAmount === undefined
}
